import Swiper from "swiper";
import { Pagination } from "swiper/modules";
import "swiper/swiper-bundle.css";
import 'swiper/css/autoplay';

export const initSlider = () => {
    const agendaSlider = document.querySelectorAll('.js-agenda-slider');

    if (!agendaSlider.length ) return;

    agendaSlider.forEach((slider) => {
        new Swiper(slider, {
            modules: [Pagination],
            spaceBetween: 20,
            slidesPerView: 1,
            slidesPerGroup: 1,
            speed: 1000,
            autoHeight: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                  slidesPerView: 2,
                  slidesPerGroup: 2,
                },
                1024: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        })
    })
}